import { EventEmitter, OnInit } from '@angular/core';
var FinalStepComponent = /** @class */ (function () {
    function FinalStepComponent() {
        this.nextStepEvent = new EventEmitter();
    }
    FinalStepComponent.prototype.ngOnInit = function () {
    };
    FinalStepComponent.prototype.nextStep = function () {
        this.nextStepEvent.emit({
            nextStep: 'close'
        });
    };
    return FinalStepComponent;
}());
export { FinalStepComponent };
